import { AddProductLoadingController } from './add-product-loading.controller.js'

function addProductLoading () {
  return {
    restrict: 'E',
    templateUrl: '/admin/directives/add-product-loading/add-product-loading.html?$$REVISION$$',
    controller: AddProductLoadingController
  }
}

export { addProductLoading }
